export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const GO_LOGIN = 'goLogin';
export const SAVE_AUTH_USER = 'saveAuthUser';
export const CLEAR_ACCESS_TOKEN = 'clearAccessToken';
export const SAVE_ACCESS_TOKEN = 'saveAccessToken';
export const TOGGLE_IS_FETCHING_ACCESS_TOKEN = 'toggleAlreadyFetchAccessToken';
